// extracted by mini-css-extract-plugin
export var chip = "_4b-0";
export var filterDropdown = "_4b-5";
export var filterItem = "_4b-6";
export var icon = "_4b-1";
export var removeButton = "_4b-3";
export var removeIcon = "_4b-4";
export var separator = "_4b-2";